module.exports = __webpack_public_path__ + "img/Proliferation-PRCA_10X_ANS.7f1d4218.png";